export default __webpack_public_path__ + "static/media/download-on-playstore.a563080d.png";